import axios from "axios";

const PRODUCTION_MAILER = "https://lawhaetae.com/mail";

export function sendMail(subject, text, from, to) {
  const data = { subject, text, from, to };
  return axios.post(PRODUCTION_MAILER, data);
}
